<button
  class="btn btn-neutral btn-block"
  appModalOpen="settings"
  appAnalyticsClick="Meta:Settings"
  appSfx="ui-error"
  [sfxTrigger]="['hover', 'click']"
>
  Settings
</button>

<div *appTeleportTo="'menu-options'">
  <app-modal
    modalId="settings"
    [allowEscToClose]="true"
    [widthClass]="'max-w-[unset]'"
  >
    <app-panel-options replacement></app-panel-options>
  </app-modal>
</div>
